import { useInView } from 'motion/react';
import { useRef } from 'react';

import { AnimatedWords } from './animated-words';

import { cn } from '~/lib/utils';

interface ProductDescriptionSectionProps {
  text: string;
  className?: string;
  textClassName?: string;
}

/**
 * Centered body-text description block.
 * Defence-tech motion: controlled fade + subtle Y-shift, 600ms duration.
 */
export const ProductDescriptionSection = ({
  text,
  className,
  textClassName,
}: ProductDescriptionSectionProps) => {
  const ref = useRef<HTMLParagraphElement>(null);
  const isInView = useInView(ref, { once: true, amount: 0.4 });

  return (
    <section
      className={cn(
        'flex w-full flex-col items-center bg-black px-4 py-[80px] md:px-20',
        className
      )}
    >
      <p
        ref={ref}
        className={cn(
          'max-w-[560px] text-center font-manrope text-[20px] font-normal leading-[1.4] text-white',
          textClassName
        )}
      >
        <AnimatedWords
          text={text}
          as="span"
          isInView={isInView}
          wordClassName="will-change-transform"
          initial={{ y: '40%', opacity: 0 }}
          animate={{ y: '0%', opacity: 1 }}
          transition={{
            duration: 0.6,
            ease: [0.4, 0, 0.2, 1],
            opacity: {
              duration: 0.9,
              ease: [0.4, 0, 0.2, 1],
            },
          }}
          delayStep={0.03}
        />
      </p>
    </section>
  );
};
